export function Success() {
    return (<div>Thank you for your feedback!</div>)
}